// export default "https://abhimanbe.tk";
// export default "server/";
// export default "https://oseas-api.hypen.lk/";
export default "https://oseas-api.hypen.lk/";
// export default "https://oseas-api.hypen.lk/";
// export default "";

const API_V = "api/v1";
export const EDITS_API = API_V + "/forms";
export const EMPLOYEE_API = API_V + "/employees";
export const ROLE_API = API_V + "/roles";
export const CUSTOMER_API = API_V + "/customers";
export const ACTIVITY_API = API_V + "/activities";
export const FIN_API = API_V + "/finances";
export const MEDIA_API = API_V + "/media";
export const REMARK_API = API_V + "/remarks";
export const UTILS_API = API_V + "/utils";
export const DEPARTMENT_API = API_V + "/departments";
export const DESIGNATION_API = API_V + "/designations";
export const INQUIRY_TYPE_API = API_V + "/inquiryTypes";
export const FEED_API = API_V + "/feeds";
export const INQUIRY_API = API_V + "/inquiries";
export const CANDIDATE_API = API_V + "/candidates";
export const LEAD_API = API_V + "/leads";
export const JOB_ORDER_API = API_V + "/joborder";
export const CVDATA_API = API_V + "/candidates/cvs";
export const CVDATA_UPDATE_API = API_V + "/candidates/cvsupdate";  

